import React from 'react';
import styled from 'styled-components';
import { FlexColumn } from '../../Reusable/Container';
import hexToRgba from 'hex-to-rgba';

const OverlayWrapper = styled(FlexColumn)`
    position: relative;
    width: 100%;
    min-height: 400px; // Match CardContainer's min-height
    border-radius: 24px;
    overflow: hidden;
`;

const OverlayContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: 'center';
    justify-content: ${props => props.fadeDirection === 'left' ? 'flex-start' : ((props.fadeDirection === 'bottom' || props.radial) ? 'center' : 'flex-end')};
    background: ${props => props.radial ? 
        `radial-gradient(
            circle at center,
            ${hexToRgba(props.theme.colors.fadeColor, 1.0)} 0%,
            ${hexToRgba(props.theme.colors.fadeColor, 0.99)} 40%,
            ${hexToRgba(props.theme.colors.fadeColor, 0.7)} 80%
        )` 
    :   `linear-gradient(to ${props.fadeDirection}, 
            ${hexToRgba(props.theme.colors.fadeColor, 0.0)} 0%, 
            ${hexToRgba(props.theme.colors.fadeColor, props.small ? 0.8 : 0.8)} 20%, 
            ${hexToRgba(props.theme.colors.fadeColor, 1.0)} 100%)`};
    padding: 40px 80px;
    box-sizing: border-box;
    border-radius: 24px;
`;

const OverlayImg = styled.img`
    position: absolute;
    width: 125%;
    height: 100%;
    z-index: 1;
    opacity: 0.2;
`;

const MessageContainer = styled.div`
    max-width: ${props => props.small ? '100%': '60%'};
    display: flex;
    align-items: center;
    justify-content: ${props => props.fadeDirection !== 'left' ? 'flex-start' : 'flex-end'};
    z-index: 2;
`;

const OverlayContainer = ({ children, fadeDirection = 'right', messageDirection, message, olImg, olImgWidth, small, radial }) => {
    return (
        <OverlayWrapper>
            {children}
            {olImg && <OverlayImg src={olImg} style={{ width: olImgWidth || '150%' }} />}
            <OverlayContent fadeDirection={fadeDirection} small={small} radial={radial}>
                <MessageContainer small={small} fadeDirection={messageDirection || fadeDirection} style={{ maxWidth: small && "100%" }}>
                    {message}
                </MessageContainer>
            </OverlayContent>
            
        </OverlayWrapper>
    );
};

export default OverlayContainer;